import '@babel/polyfill'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import {VueMasonryPlugin} from 'vue-masonry'

import AddToCartButton from '@Shared/components/catalog/AddToCartButton'
import InlineUpgrade from '@Shared/components/catalog/InlineUpgrade'
import MixAndMatchPhotoSelection from './components/PhotoSelection/PhotoSelection'
import PackageOptionFrameProduct from '@Shared/components/catalog/PackageOption/PackageOptionFrameProduct'
import PackageOptionPreviewModal from '@Shared/components/catalog/PackageOptionPreviewModal'
import PromoBanner from '@Shared/components/PromoBanner'
import RetouchingInputs from '@Shared/components/catalog/RetouchingInputs'
import RetouchingModal from '@Shared/components/catalog/RetouchingModal/RetouchingModal'
import SelectPhotoModal from '@Shared/components/catalog/SelectPhotoModal/SelectPhotoModal'
import YouMayAlsoLike from '@Shared/components/catalog/YouMayAlsoLike/YouMayAlsoLike'
import { MediaQueries } from 'vue-media-queries'

import store from './store'
import _ from 'lodash'
import VueToastr from '@deveodk/vue-toastr'
import CatalogPagesMixin from '@Shared/mixins/catalog-pages'
import ToastMixin from '@Shared/mixins/toast'
import ContentfulMixin from '@Shared/mixins/contentful'
import VueSiteIdentity from '@Shared/plugins/VueSiteIdentity'

const mediaQueries = new MediaQueries()

Vue.use(mediaQueries)
Vue.use(VueToastr)
Vue.use(VueAxios, axios)
Vue.use(VueMasonryPlugin)
Vue.use(VueSiteIdentity)

/* eslint-disable no-new */
new Vue({
  el: '#catalog-mix-app',
  store,
  mediaQueries,
  components: {
    AddToCartButton,
    InlineUpgrade,
    MixAndMatchPhotoSelection,
    PackageOptionFrameProduct,
    PackageOptionPreviewModal,
    PromoBanner,
    RetouchingInputs,
    RetouchingModal,
    SelectPhotoModal,
    YouMayAlsoLike
  },
  mixins: [
    CatalogPagesMixin,
    ContentfulMixin,
    ToastMixin
  ],
  data () {
    return {
      allowRetouching: window.pageData.catalogMix.allowRetouching,
      frameId: null,
      mixAndMatchOptionProducts: window.pageData.catalogMix.mixAndMatchOptionProducts,
      offerPackage: window.pageData.catalogMix.offerPackage,
      packageOptions: window.pageData.catalogMix.packageOptions,
      retouchingModalContent: window.pageData.catalogMix.retouchingModalContent,
      retouchingViewModel: window.pageData.catalogMix.retouchingViewModel,
      retouchingsInCart: window.pageData.catalogMix.retouchingsInCart,
      selectDifferentPhotoViewModel: window.pageData.catalogMix.selectDifferentPhotoViewModel,
      selectedFrame: window.pageData.catalogMix.selectedFrame,
      youMayAlsoLikeModuleContent: window.pageData.catalogMix.youMayAlsoLikeModuleContent
    }
  },
  computed: {
    selectedRetouchings () {
      return this.$store.state.catalogPageCommon.selectedRetouchings
    },
    mainHeadClasses () {
      return {
        'catalog__main-head': true,
        'catalog__main-head--alt-gradimages': true,
        'catalog__main-head--no-bottom-border': true
      }
    },
    content () {
      return this.$store.state.mixMatchPhotoSelectionModuleContent
    },
    promoBanner () {
      return this.$store.state.catalogPageCommon.promoBanner
    },
    promoBannerInlineContext () {
      // this property determines the context passed to the PromoBanner component
      // the context determins whether it displays a border at the top of the component
      // if there's a quanity UI a border is needed. if there is no quantity UI then no border is needed

      if (this.offerPackage.CatalogPackage.MaxQtyAllowed > 1) { // quanity ui will show
        return 'inline'
      } else {
        return 'inline-no-border'
      }
    }
  },
  watch: {
    selectedRetouchings (v, ov) {
      _.each(v, selectedRetouching => {
        this.sendRetouchingsUpdated(selectedRetouching.frameId)
      })
    }
  },
  created () {
    document.addEventListener('modal-image-select', e => {
      this.sendRetouchingsUpdated(e.detail.frameId)
    })

    document.addEventListener('photoset-image-remove', e => {
      if (e.detail.frameStillSelected === false) {
        let selectedRetouchings = _.filter(this.selectedRetouchings, (selectedRetouching) => {
          return selectedRetouching.frameId !== e.detail.frameId
        })

        this.$store.commit('updateSelectedRetouchings', selectedRetouchings)
      }
    })
  },
  methods: {
    handleRetouchingAdded (data) {
      this.$store.commit('addSelectedRetouching', {
        frameId: parseInt(data.frameId, 10),
        offerPackageId: parseInt(data.offerPackageId, 10)
      })
    },
    handleRetouchingRemoved (data) {
      this.$store.commit('removeSelectedRetouching', data)
      this.sendRetouchingsUpdated(parseInt(data.frameId, 10))
    },
    handleRetouchingFrameChanged () {
      // do nothing for this event on catalog mix
    },
    sendRetouchingsUpdated (frameId) {
      frameId = parseInt(frameId, 10)

      let alreadyInCartCount = 0

      if (_(this.retouchingsInCart).keys().map(key => {
        return parseInt(key, 10)
      }).value().indexOf(frameId) > -1) {
        alreadyInCartCount = this.retouchingsInCart[frameId].length
      }

      let selectedFrameRetouchings = _.filter(this.selectedRetouchings, selectedRetouching => {
        return selectedRetouching.frameId === frameId
      })

      let retouchingsCount = selectedFrameRetouchings.length + alreadyInCartCount

      document.dispatchEvent(new CustomEvent('retouchings.updated', {
        detail: {
          numberRetouchingsSelected: retouchingsCount,
          frameId: frameId
        }
      }))
    },
    handleAddToCartButtonClick () {
      const mixMatchSelectionsAreValid = this.$store.getters.mixMatchSelectionsAreValid
      this.$store.commit('toggleMixMatchValidationVisiblity', !mixMatchSelectionsAreValid)

      if (mixMatchSelectionsAreValid === true) {
        document.getElementById('add-to-cart-form').submit()
      } else {
        this.makeToast('error', this.contentfulText('mix-match-toast-error-title').Content, this.contentfulText('mix-match-toast-error-message').Content)
      }
    }
  }
})



// WEBPACK FOOTER //
// ./WebResources/vue/default/catalog-mix/main.js